{	"mainLJ": {
		"title": "Dnevnik pilota (jadralni)",
		"nazaj": "Nazaj"
	},
	"navsLJ": {
		"vnos": "Vnos",
		"dnevnik": "Dnevnik"
	},
	"labelsLJ": {
		"datum": "Datum :",
		"casO":"Čas odhoda :",
		"krajV":"Kraj vzleta : LJAJ",
		"naloga": "Naloga",
		"stLetov": "Št. letov",
		"casP":"Čas prihoda :",
		"krajP":"Kraj pristanka : LJAJ",
		"model":"Tip",
		"reg":"Registracija letala: S5-XYZ",
		"nacinStarta": "Način starta",
		"ime":"Ime vodje zrakoplova",
		"posadka":"Enočlanska / Veččlanska posadka :",
		"posadkaVec":"VEČ",
		"skupniCas":"Čas trajanja leta:",
		"stPristankovDN":"Št. pristankov (Dan / Noč) :",
		"dan":"Dan",
		"noc":"Noč",
		"stPristankov":"Št. pristankov :",
		"op":"Operativni pogoji :",
		"opD":"Dnevno",
		"opN":"Slepo",
		"vlogaP":"Vloga pilota :",
		"fstd":"Skupni čas na FSTD:",
		"kilometri": "Preleteni kilometri",
		"opomba":"Opomba"
	},
	"buttonsLJ": {
		"vnesiZapis": "Vnesi zapis"
	},
	"optionsLJ": {
		"aerozaprega": "A - Aerozaprega",
		"vitla": "V - Vitla"
	},
	"obvestilaLJ": {
		"zapisDodan": "Zapis uspešno dodan.",
		"napakaVnosa": "Napaka pri vnosu podatkov.",
		"napakaInputa": "Za dodajanje zapisa morajo biti izpolnjeni vsi podatki. Preverite, da ste izpolnili vse podatke!",
		"napakaBranja": "Napaka pri branju podatkov."
	}
}